// extracted by mini-css-extract-plugin
export var isPrintedCell = "_yy-1";
export var printerIcon = "_yy-0";